import { atom } from "jotai";
import {
    RouterProvider,
    createBrowserRouter,
    redirect,
} from "react-router-dom";
// import PaymentMethod from "./routes/PaymentMethod";
// import OtherUploads from "./routes/OtherUploads";
import Summary from "./routes/Summary";
import ThankYou from "./routes/ThankYou";
import SendFailed from "./routes/SendFailed";
// import { FormModel, TravelSearchModel } from "./types/FormTypes";
import Root from "./routes/root";
import Intro from "./routes/Intro";
// import TravelSearch from "./routes/TravelSearch";


import { FormModel } from "./types/FormTypes";
import SurchargeNumber from "./routes/SurchargeNumber";
import TicketDetails from "./routes/TicketType";
import TicketWithApp from "./routes/TicketWithApp";
import TicketWithBlip from "./routes/TicketWithBlip";
import TicketWithTravelcard from "./routes/TicketWithTravelcard";
import Description from "./routes/Description";
import ContactDetails from "./routes/ContactDetails";
import AgeCheck from "./routes/AgeCheck";
import AppealForWho from "./routes/AppealForWho";
import TicketWithPaperTicket from "./routes/TicketWithPaperTicket";

// import AddCertificate from "./routes/AddCertificate";
require("./extensions/yup-extensions");

/*
    Store  - Collecting Travel Search Data 
*/

// export const travelSearchAtom = atom<TravelSearchModel>({
//     selectedJourneyFrom: null,
//     selectedJourneyTo: null,
//     journeyDate: '',
//     journeyTime: '',
// });

/*
    Store - Collecting FormData
*/

export const formDataAtom = atom<FormModel>({
    surchargenumber: "",
    phone: "",
    ticketType: "",
    travelcardnumber: "",
    ticketNumber: "",
    description: "",
    agecheck: "",
    appealforwho: "",
    reporterEmail: "",
    firstname: "",
    lastname: "",
    email: "",

    // selectedJourney: { fromName: '', toName: '', date: '', travelTime: '', journeyKey: '', line: '', switches: '', unformattedDate: '' },
});


// export const selectedJourneyAtom = atom({
//     fromName: '',
//     toName: '',
//     date: '',
//     travelTime: '',
//     journeyKey: '',
//     line: '',
//     switches: '',
//     unformattedDate: '',
// });

const state = { followingForm: false };
const routerBasename = (window as any).OGT?.WebApp?.routerBasename ?? "";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                index: true,
                element: <Intro />,
                loader: () => {
                    state.followingForm = true;
                    return null;
                }
            },
            {
                path: "tillaggsavgiftsnummer",
                element: <SurchargeNumber />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "biljettdetaljer",
                element: <TicketDetails />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "biljett-med-app",
                element: <TicketWithApp />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "biljett-med-resekort",
                element: <TicketWithTravelcard />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "biljett-med-blipp",
                element: <TicketWithBlip />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "pappersbiljett",
                element: <TicketWithPaperTicket />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "vad-var-det-som-hande",
                element: <Description />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ar-du-over-18",
                element: <AgeCheck />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "vem-overklagar-du-for",
                element: <AppealForWho />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "kontaktuppgifter",
                element: <ContactDetails />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "sammanfattning",
                element: <Summary />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "tack",
                element: <ThankYou />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ett-fel-intraffade",
                element: <SendFailed />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
        ],
    },
],
    {
        basename: routerBasename
    }
);

// Count pages WIP
const pagePaths =
    router?.routes[0]?.children?.map((child) => child.path).filter(Boolean) || [];

export const pageCountAtom = atom({
    pagePaths,
});

function App() {
    // const [formData] = useAtom(formDataAtom);
    // const [medicalVisit] = useAtom(medicalVisitAtom);

    return (
        <>
            <RouterProvider router={router} />
            {/* <div className="bg-slate-900 text-white p-6 text-xs  grid-cols-2 gap-10 hidden md:grid">
        <pre>{JSON.stringify(formData, null, 2)}</pre>
        <pre>{JSON.stringify(medicalVisit, null, 2)}</pre>
      </div> */}
        </>
    );
}

export default App;
